/**
 * Represents how a Tech Enablement Fee amount is expressed.
 */
export enum FeeAmountTypeModel {
	/**
	 * The fee is a percentage of paid claims.
	 */
	Percentage = 1,
	/**
	 * The fee is a fixed dollar amount.
	 */
	Fixed = 2
}
